import { render, staticRenderFns } from "./layout-features.vue?vue&type=template&id=4350aeaa&scoped=true"
import script from "./layout-features.vue?vue&type=script&lang=js"
export * from "./layout-features.vue?vue&type=script&lang=js"
import style0 from "./layout-features.vue?vue&type=style&index=0&id=4350aeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350aeaa",
  null
  
)

export default component.exports